import { defineMessages } from 'react-intl';

const scope = 'app.containers.CalculationForms.components.RateChangeImpact';

export default defineMessages({
    calculatorTitle: {
        id: `${scope}.calculatorTitle`,
        description: 'The title for the calculator',
        defaultMessage: 'Rate Change Impact Calculator',
    },
    subHeading: {
        id: `${scope}.subHeading`,
        description: 'Subheading for the calculator',
        defaultMessage: 'Calculate the impact of your rate change',
    },
    totalRooms: {
        id: `${scope}.totalRooms`,
        description: 'Total rooms input label',
        defaultMessage: 'Total rooms',
    },
    currentRate: {
        id: `${scope}.currentRate`,
        description: 'Current rate input label',
        defaultMessage: 'Current rate',
    },
    proposedRate: {
        id: `${scope}.proposedRate`,
        description: 'Proposed rate input label',
        defaultMessage: 'Proposed rate',
    },
    costOfOccupiedRoom: {
        id: `${scope}.costOfOccupiedRoom`,
        description: 'Cost of occupied room label',
        defaultMessage: 'Cost of occupied room',
    },
    forecastedOccupance: {
        id: `${scope}.forecastedOccupancy`,
        description: 'Forecasted occupancy label',
        defaultMessage: 'Forecasted occupancy',
    },
    forecastedActual: {
        id: `${scope}.forecastedActual`,
        description: 'Forecasted actual label',
        defaultMessage: 'Forecasted Actual',
    },
    calculateButtonLabel: {
        id: `${scope}.calculateButtonLabel`,
        description: 'Label for calculate button',
        defaultMessage: 'Calculate',
    },
    resultsRequired: {
        id: `${scope}.resultsRequired`,
        description: 'Heading for the results section',
        defaultMessage: 'Results required to achieve the same revenue',
    },
    resultsDescription: {
        id: `${scope}.resultsDescription`,
        description: 'Description of the meaning of the results',
        defaultMessage:
            'The results below describe how your business would need to change, following a rate update, to achieve the same revenue. Both in terms of occupancy required and rooms sold.',
    },
    newOccupancy: {
        id: `${scope}.newOccupancy`,
        description: 'Label for new occupancy value in results',
        defaultMessage: 'Occupancy required',
    },
    additionalOccupancy: {
        id: `${scope}.additionalOccupancy`,
        description: 'Label for additional occupancy in results',
        defaultMessage: 'Occupancy change',
    },
    newRooms: {
        id: `${scope}.newRooms`,
        description: 'Label for new rooms value in results',
        defaultMessage: 'Rooms required',
    },
    actualRooms: {
        id: `${scope}.actualRooms`,
        description: 'Label for actual rooms in results',
        defaultMessage: 'Rooms change',
    },
    errorMessage: {
        id: `${scope}.errorMessage`,
        description: 'Error message if all fields not filled in',
        defaultMessage: 'All inputs must be filled',
    },
    exportToCSV: {
        id: `${scope}.exportToCSV`,
        description: 'Button label for export to CSV',
        defaultMessage: 'Export to CSV',
    },
    occupancyGraphLabel: {
        id: `${scope}.occupancyGraphLabel`,
        description: 'Label for occupancy graph',
        defaultMessage: 'Occupancy required',
    },
    roomsGraphLabel: {
        id: `${scope}.roomsGraphLabel`,
        description: 'Label for rooms graph',
        defaultMessage: 'Room sales required',
    },
    beforeChangeLabel: {
        id: `${scope}.beforeChangeLabel`,
        description: 'Label for before bar of graph',
        defaultMessage: 'Before change',
    },
    afterChangeLabel: {
        id: `${scope}.afterChangeLabel`,
        description: 'Label for after bar of graph',
        defaultMessage: 'After change',
    },
    roomsSuffix: {
        id: `${scope}.roomsSuffix`,
        description: 'Suffix to show that the value denotes rooms',
        defaultMessage: 'rooms',
    },
    dropRateConsider: {
        id: `${scope}.dropRateConsider`,
        description: 'Message about dropping rate',
        defaultMessage:
            'If your consideration for dropping rate is to generate demand, please consider how difficult it may be to sell additional rooms during what already may be a quiet period.',
    },
    raiseRateConsider: {
        id: `${scope}.raiseRateConsider`,
        description: 'Message about raising rate',
        defaultMessage:
            'If your consideration for increasing rate is to generate additional revenue, please consider how this may impact occupancy and overall TrevPar.',
    },
});
